import { render, staticRenderFns } from "./Occupants.vue?vue&type=template&id=0c0136a8"
import script from "./Occupants.vue?vue&type=script&lang=js"
export * from "./Occupants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports